/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Verify_FailedInputs */

const he_auth_verify_failed = /** @type {(inputs: Auth_Verify_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`האימות נכשל`)
};

const en_auth_verify_failed = /** @type {(inputs: Auth_Verify_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verification Failed`)
};

/**
* | output |
* | --- |
* | "Verification Failed" |
*
* @param {Auth_Verify_FailedInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_verify_failed = /** @type {((inputs?: Auth_Verify_FailedInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Verify_FailedInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_verify_failed(inputs)
	return en_auth_verify_failed(inputs)
});